/**
 * Transforme la réponse de GET /hr/pilotage/temps-travail en modèle
 * consommé par TempsSection.
 */
export const mapTempsTravail = (api) => ({
    pctRealise: api.realized_hours_pct ?? 0,
    ecartTheorique: api.theoretical_hours_gap ?? 0,
    heuresSup: api.overtime_hours ?? 0,
    telePct: api.remote_work_pct ?? 0,
    presentielPct: api.onsite_work_pct ?? 0,
    teleJours: api.average_remote_days ?? 0,
});
